if (!customElements.get('product-configurator')) {
  /**
   *  @class
   *  @function ProductConfigurator
   */
  class ProductConfigurator extends HTMLElement {
    constructor() {
      super();

      this.stringingInput = this.querySelector('[name="properties[Stringing]"]');
      
      this.productSection = this.closest('.thb-product-detail');
      this.productForm = this.productSection.querySelector('form[action="/cart/add"]');

      this.buttonOuter = this.productSection.querySelector('.product-buy-buttons');
      this.buyButtonHTML = this.buttonOuter.innerHTML;

      this.forms = document.querySelectorAll('product-configurator-form');

      document.addEventListener('configurator:reset', this.resetConfigurator.bind(this));
    }

    connectedCallback() {
      this.resetFormData();
      this.stringingInput.addEventListener('change', this.onStringingChange.bind(this));

      document.addEventListener(
        'configurator:type:update', 
        function(evt) {
          this.setConfiguratorType(evt.detail.type);
          this.currentType = this.getConfiguratorType();
          this.configureFormData();
        }.bind(this)
      );
    }

    onStringingChange() {
      this.updateStringingProperty();
      this.updateAddButton();
    }

    updateStringingProperty() {
      const stringingPropertyInput = this.productForm.querySelector('input[name="property[Stringing]"]');
      
      if (stringingPropertyInput) {
        stringingPropertyInput.value = this.stringingInput.value;
        stringingPropertyInput.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      }
    }

    updateAddButton() {
      this.targetKey = this.stringingInput.options[this.stringingInput.selectedIndex].dataset.optionValue;

      switch (this.targetKey) {
        case 'unstrung':
          this.buttonOuter.innerHTML = this.buyButtonHTML;
          this.resetConfigurator();
          break; 
        case 'strung':
          this.configureButtonHTML = `
            <label class="form__label visibility-hidden">Configure</label>
            <modal-opener class="add_to_cart_holder product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-Configurator">
              <button id="ProductPopup-Configurator" name="configure" class="single-add-to-cart-button button accent" type="button" aria-haspopup="dialog">
                <span class="single-add-to-cart-button--text">Configure</span>
              </button>
            </modal-opener>
          `;
          this.buttonOuter.innerHTML = this.configureButtonHTML;
          this.configureButton = this.buttonOuter.querySelector('[name="configure"]');
          this.triggerTypeUpdate(this.targetKey);
          this.resetConfigurator();
          break;
        case 'hybrid':
          this.configureButtonHTML = `
            <label class="form__label visibility-hidden">Configure</label>
            <modal-opener class="add_to_cart_holder product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-Configurator-Hybrid">
              <button id="ProductPopup-Configurator-Hybrid" name="configure" class="single-add-to-cart-button button accent" type="button" aria-haspopup="dialog">
                <span class="single-add-to-cart-button--text">Configure</span>
              </button>
            </modal-opener>
          `;
          this.buttonOuter.innerHTML = this.configureButtonHTML;
          this.configureButton = this.buttonOuter.querySelector('[name="configure"]');
          this.triggerTypeUpdate(null);
          this.resetConfigurator();
          break;
        case 'unstrung-ship-strings-separate':
          this.buttonOuter.innerHTML = this.buyButtonHTML;
          this.resetConfigurator();
          break;
      }
    }

    resetConfigurator() {
      this.resetFormData();
      this.resetModalView();

      this.forms.forEach(form => {
        if (typeof form.resetStates === 'function') {
          form.resetStates();
        }
      });
  
      document.dispatchEvent(
        new CustomEvent('configurator:view:toggle', {
          bubbles: true,
          detail: {
            to: 'default',
            from: 'default'
          }
        })
      );
  
      this.forms.forEach(form => {
        this.triggerFormUpdate(form);
      });
  
      this.setConfiguratorType(this.targetKey);

      this.configureFormData();
    }
    
    configureFormData() {
      this.currentForm = document.querySelector(`product-configurator-form[data-configurator-type="${this.currentType}"]`);
      if (!this.currentForm) return;

      this.resetFormData();

      const variantIdInput = this.productForm.querySelector('input[name="id"]');
      const quantityInput = this.productSection.querySelector('input[name="quantity"]');
      const variantPriceElem = this.productSection.querySelector('.price');
      const variantPriceAttr = variantPriceElem.getAttribute('data-price');
      const productHandleAttr = this.productSection.getAttribute('data-handle');

      const variantId = parseFloat(variantIdInput.value);
      const quantity = parseFloat(quantityInput.value);
      const price = parseFloat(variantPriceAttr);
      const handle = productHandleAttr ? productHandleAttr : null;

      if (isNaN(variantId) || isNaN(quantity) || quantity < 1) return;

      const data = {
        id: variantId,
        quantity: quantity,
        properties: {
          Stringing: this.stringingInput.value
        },
        _helpers: {
          _type: 'primary',
          _handle: handle,
          _price: price
        }
      }

      const foundPrimary = this.formData.find((item) => item._helpers?._type === 'primary');
      if (foundPrimary) {
        // remove
        this.formData = this.formData.filter((item) => item._helpers?._type !== 'primary');
      }
      this.formData.push(data);

      this.triggerFormUpdate(this.currentForm);
    }

    resetFormData() {
      this.formData = [];
      this.forms.forEach((form) => { this.triggerFormUpdate(form); })
    }

    resetModalView() {
      this.triggerModalViewUpdate('default', 'default');
    }

    setConfiguratorType(type) {
      this.oldType = window.configurator._helpers._type;
      window.configurator._helpers._type = type;
      window.configurator._helpers._subtypes = type === 'hybrid-b' ? ['mains', 'crosses'] : ['none'];
    }

    triggerFormUpdate(form) {
      form.dispatchEvent(
        new CustomEvent("configurator:form:update", {
          bubbles: true,
          detail: {
            data: this.formData
          }
        })
      );
    }

    triggerTypeUpdate(type) {
      document.dispatchEvent(
        new CustomEvent("configurator:type:update", {
          bubbles: true,
          detail: {
            type: type
          }
        })
      )
    }

    triggerModalViewUpdate(to, from) {
      document.dispatchEvent(
        new CustomEvent('configurator:view:toggle', {
          bubbles: true,
          detail: {
            to: to,
            from: from
          }
        })
      )
    }

    getFormData() {
      return window.configurator.formData;
    }

    getConfiguratorType() {
      return window.configurator._helpers._type;
    }
  }

  customElements.define('product-configurator', ProductConfigurator);
}

if (!customElements.get('product-configurator-modal')) {
  /**
   *  @class
   *  @function ProductConfiguratorModal
   */
  class ProductConfiguratorModal extends HTMLElement {
    constructor() {
      super();
      
      this.outer = this.closest('modal-dialog');
      this.form = this.querySelector('product-configurator-form');

      this.toggleViewButtons = this.outer.querySelectorAll('[data-configurator-modal-view-toggle]');
      this.views = this.querySelectorAll('[data-configurator-modal-view]');
      this.currentView = this.querySelector('[data-configurator-modal-view="default"]');
      this.headerViews = this.outer.querySelectorAll('[data-configurator-modal-header-view]');
      this.currentHeaderView = this.outer.querySelector('[data-configurator-modal-header-view="default"]');

      this.formData = this.getFormData();
    }

    connectedCallback() {
      this.configureNavigation();

      this.toggleViewButtons.forEach((button) => {
        button.addEventListener('click', this.onToggelModalView.bind(this));
      });

      this.form.addEventListener(
        "configurator:form:update", 
        function(evt) {
          this.formData = evt.detail.data;
          this.configureNavigation();
        }.bind(this)
      );

      document.addEventListener(
        'configurator:view:toggle', 
        function(evt) {
          var to = evt.detail.to;
          var from = evt.detail.from;
          this.toggleModalView(to);
          this.setNavBack(from);
        }.bind(this)
      );
    }

    configureNavigation() {
      if (!this.currentView) return;

      const currentViewKey = this.currentView.getAttribute('data-configurator-modal-view');
      
      this.navBackButton = this.outer.querySelector(
        `[data-configurator-modal-header-view="${currentViewKey}"] [data-configurator-modal-nav-back]`
      );
      this.navForwardButton = this.outer.querySelector(
        `[data-configurator-modal-header-view="${currentViewKey}"] [data-configurator-modal-nav-forward]`
      );
      
      const navBackKey = this.navBackButton.getAttribute('data-configurator-modal-view-toggle');
      const navForwardKey = this.navForwardButton.getAttribute('data-configurator-modal-view-toggle');

      // back
      if (currentViewKey === navBackKey) { this.navBackButton.classList.add('is-hidden'); }
      else { this.navBackButton.classList.remove('is-hidden'); }

      // forward
      this.navForwardButton.classList.add('is-hidden');
      if (currentViewKey !== navForwardKey) {
        if (navForwardKey === 'summary') {
          const selectedPrimary = this.formData.find((item) => item._helpers?._type === 'primary');
          const selectedSecondaryArr = this.formData.filter((item) => item._helpers?._type === 'secondary');
          if (selectedPrimary && selectedSecondaryArr.length === window.configurator._helpers._subtypes.length) { 
            this.navForwardButton.classList.remove('is-hidden'); 
          }
        } else {
          this.navForwardButton.classList.remove('is-hidden'); 
        }
      }
    }

    onToggelModalView(evt) {
      const target = evt.currentTarget;
      const key = target.getAttribute('data-configurator-modal-view-toggle');
      const type = target.getAttribute('data-configurator-type');

      this.toggleModalView(key);

      if (type) {
        this.form.setAttribute('data-configurator-type', type); 
        document.dispatchEvent(
          new CustomEvent("configurator:type:update", {
            bubbles: true,
            detail: {
              type: type
            }
          })
        );
      }
    }

    toggleModalView(key) {
      this.currentView = this.querySelector(`[data-configurator-modal-view="${key}"]`);
      this.currentHeaderView = this.outer.querySelector(`[data-configurator-modal-header-view="${key}"]`)
      if (!this.currentView || !this.currentHeaderView) return;

      this.views.forEach((view) => { view.classList.add('is-hidden'); });
      this.currentView.classList.remove('is-hidden');

      this.headerViews.forEach((view) => { view.classList.add('is-hidden'); });
      this.currentHeaderView.classList.remove('is-hidden');

      this.configureNavigation();
    }

    setNavBack(key) {
      if (!this.navBackButton) return;
      this.navBackButton.setAttribute('data-configurator-modal-view-toggle', key);
    }

    getFormData() {
      return window.configurator.formData;
    }
  }

  customElements.define('product-configurator-modal', ProductConfiguratorModal);
}

if (!customElements.get('product-configurator-form')) {
  /**
   *  @class
   *  @function ProductConfiguratorForm
   */

  const PRODUCT_CONFIGURATOR_FORM_STORAGE_KEY = 'PRODUCT_CONFIGURATOR_FORM_STORAGE_KEY';

  class ProductConfiguratorForm extends HTMLElement {
    constructor() {
      super();

      this.outer = this.closest('modal-dialog');
    
      this.count = this.querySelector('[data-configurator-summary-count]');
      this.subtotal = this.querySelector('[data-configurator-summary-subtotal]');
      this.submit = this.querySelector('[name="configurator-form-submit"]');
      this.submitError = this.querySelector('[data-configurator-submit-error]');
      this.formBody = this.querySelector("[data-configurator-summary-body]");
    }

    connectedCallback() {
      this.addEventListener(
        "configurator:form:update", 
        function(evt) {
          if (this.isRendering) return;

          var data = evt.detail.data;
          this.oldFormData = this.formData;
          this.storeFormData(data);
          this.renderForm();
        }.bind(this)
      );

      this.submit.addEventListener('click', this.onFormSubmit.bind(this));
    }

    renderForm() {
      if (!this.formData || !this.formData.length) return;
      
      this.isRendering = true;  // Set flag before rendering
      
      const promisesArr = this.fetchFormPromises(this.formData);

      Promise
        .all(promisesArr)
        .then((markupArr) => {
          const markupMerged = markupArr.reduce((a, b) => a + b);
          this.formBody.innerHTML = markupMerged;
        })
        .catch((error) => {
          console.warn(error);
        })
        .finally(() => {
          this.updateState();
          window.configurator._helpers._subtypes.forEach((subtype) => {
            this.triggerStateUpdates(subtype);
          });
          this.isRendering = false;  // Reset flag after everything is done
        });
    }

    fetchFormPromises(formData) {
      const foundPrimary = formData.find((item) => item._helpers?._type === 'primary');
      const primaryHandle = foundPrimary._helpers?._handle;

      return formData.map((item) => {
        const variantId = item.id; 
        const type = item._helpers?._type;
        const subtype = item._helpers?._subtype;
        const slug = `${window.configurator._helpers._type}${ (item._helpers?._subtype !== 'none' && item._helpers?._subtype_index) ? ('-' + item._helpers?._subtype_index) : ''}`;
        var apiRowProperties = document.createElement('div');

        return new Promise((resolve, reject) => {
          window
            .fetch(`${theme.routes.root_url}products/${primaryHandle}?section_id=api-product-configurator-properties-${slug}`)
            .then((response) => {
              return response.text();
            })
            .then((response) => {
              apiRowProperties.innerHTML = response;
              return fetch(`${theme.routes.root_url}variants/${variantId}/?section_id=api-product-configurator-summary-item-${slug}`);
            })
            .then((response) => {
              return response.text();
            })
            .then((response) => {
              // handle success
              const fresh = document.createElement('div');
              fresh.innerHTML = response;
              
              // set row heading
              var rowHeading = '';
              if (type === 'primary') { 
                rowHeading = theme.configuratorStrings.primary; 
              } else if (type === 'secondary') { 
                rowHeading = theme.configuratorStrings.secondary; 
                if (subtype === 'mains') { 
                  rowHeading += ` &#40;${theme.configuratorStrings.mains}&#41;`; 
                } else if (subtype === 'crosses') { 
                  rowHeading += ` &#40;${theme.configuratorStrings.crosses}&#41;`;
                }
              } else if (type === 'add_on') { 
                rowHeading = theme.configuratorStrings.addOn; 
              }

              // configure row
              const rowOptions = fresh.querySelector('[data-configurator-summary-item-options]');
              const rowProperties = fresh.querySelector('[data-configurator-summary-item-properties]');
              const rowRemoveButton = fresh.querySelector('[data-configurator-summary-item-remove]');
              const rowQuantityInput = fresh.querySelector('[data-configurator-summary-item-quantity]');
              if (type === 'secondary') { 
                rowOptions.classList.remove('is-hidden');
                rowProperties.innerHTML = apiRowProperties.querySelector('[data-api-content]').innerHTML;
                rowProperties.classList.remove('is-hidden');;

                if (item.properties) {
                  Object.entries(item.properties).forEach(([propertyName, propertyValue]) => {
                    const select = rowProperties.querySelector(`select[name="properties[${propertyName}]"]`);
                    
                    if (select) {
                      Array.from(select.options).forEach(opt => opt.removeAttribute('selected'));
                      
                      const option = Array.from(select.options).find(opt => opt.value === propertyValue);
                      if (option) {
                        option.setAttribute('selected', 'selected');
                        select.value = propertyValue;
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                      }
                    }
                  });
                }
              } else if (type === 'add_on') {
                rowRemoveButton.classList.remove('is-hidden');
                rowQuantityInput.classList.remove('is-hidden');
              }

              // render row
              const freshInner = fresh.querySelector('[data-api-content]').innerHTML;
              const freshOuter = `
               <div 
                  data-configurator-summary-row
                  data-variant-id=${variantId}
                >
                <div class="summary-heading">
                  <span>${rowHeading}</span>
                </div>
                ${item._helpers?._type === 'secondary' ? 
                  `<product-configurator-item-form
                    data-product-id="${item._helpers?._product_id}"
                    data-configurator-modal-view-origin="summary"
                    data-configurator-item-type="${item._helpers?._subtype}"
                  >
                    ${freshInner}
                  </product-configurator-item-form>` 
                  : 
                  (item._helpers?._type === 'add_on' ? 
                  `<product-configurator-upsell-item-form
                    data-variant-id="${item.id}"
                    data-price="${item._helpers?._price}"
                  >
                    ${freshInner}
                  </product-configurator-upsell-item-form>`
                  :
                  `${freshInner}`)}
                </div>
              `
              resolve(freshOuter);
            })
            .catch((error) => {
              reject(error);
            })
        })
      })
    }

    onFormSubmit(evt) {
      evt.preventDefault();

      if (!this.formData.length) return;

      this.submit.setAttribute('disabled', 'disabled');
      this.submit.classList.add('loading');
      
      const bodyItems = this.formData.map((item) => {
        return {
          id: item.id,
          quantity: item.quantity,
          properties: {...item.properties, _racquet: item._helpers?._racquet},
        }
       });
      const body = {
        items: bodyItems
      };
      
      fetch(`${theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json' 
        },
        body: JSON.stringify(body)
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status == 422) {
          if (typeof response.description === "string") {
            this._renderCartError(response.description);
          } else {
            this._renderCartError(response.message);
          }
          return false;
        }
        return fetch("?section_id=api-cart-helper"); 
      })
      .then((response) => response.text())
      .then((text) => {
        this._renderCartDrawer(text);
        // close and reset modal
        this.outer.hide();
        this.resetConfigurator();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submit.classList.remove('loading');
        this.submit.removeAttribute('disabled');
      });
    }

    resetConfigurator() {
      this.resetFormData();
      this.resetStates();
      this.resetModalState();
      document.dispatchEvent(new CustomEvent('configurator:reset', { bubbles: true }));
    }

    updateState(){
      this.updateCount();
      this.updateSubtotal();
    }

    updateCount() {
      const count = this.formData.reduce((a, b) => a + b.quantity, 0);
      this.count.textContent = count;
    }

    updateSubtotal() {
      let subtotal = this.formData.reduce((a, b) => a + b._helpers?._price, 0);
      let format = window.theme.settings.money_with_currency_format || "${{amount}}";
      
      this.subtotal.textContent = formatMoney(subtotal, format);
    }

    triggerStateUpdates(subtype) {
      var instancesToSelect = [];
      var instancesToUnselect = [];
      
      const selectedSecondary = this.formData.find((item) => item._helpers?._type === 'secondary' && item._helpers?._subtype === subtype);


      if (selectedSecondary) {
        var selectedSecondaryProductId = selectedSecondary._helpers?._product_id;
        var selectedSecondaryViewOrigin = selectedSecondary._helpers?._view_origin;
        var selectedSecondarySubtype = selectedSecondary._helpers?._subtype;

        const prevSelectedSecondary = this.oldFormData.find((item) => item._helpers?._type === 'secondary' && item._helpers?._subtype === selectedSecondarySubtype);
        var selectedSecondaryProductChanged = prevSelectedSecondary && selectedSecondaryProductId !== prevSelectedSecondary._helpers?._product_id;
        
        if (selectedSecondaryProductChanged) {
          // unselect other selected instances
          instancesToUnselect = this.outer.querySelectorAll(
            `product-configurator-item-form[data-configurator-item-type="${selectedSecondarySubtype}"].is-selected:not([data-product-id="${selectedSecondaryProductId}"])`
          )
          // select analogous instances
          // select current instance if summary item
          instancesToSelect = this.outer.querySelectorAll(
            `product-configurator-item-form[data-product-id="${selectedSecondaryProductId}"][data-configurator-item-type="${selectedSecondarySubtype}"]:not([data-configurator-modal-view-origin="${selectedSecondaryViewOrigin}"]),
             product-configurator-item-form[data-product-id="${selectedSecondaryProductId}"][data-configurator-item-type="${selectedSecondarySubtype}"][data-configurator-modal-view-origin="summary"]`
          )
        } else {
          // select analogous instances
          // select current instance if summary item
          instancesToSelect = this.outer.querySelectorAll(
            `product-configurator-item-form[data-product-id="${selectedSecondaryProductId}"][data-configurator-item-type="${selectedSecondarySubtype}"]:not([data-configurator-modal-view-origin="${selectedSecondaryViewOrigin}"]),
             product-configurator-item-form[data-product-id="${selectedSecondaryProductId}"][data-configurator-item-type="${selectedSecondarySubtype}"][data-configurator-modal-view-origin="summary"]`
          )
        }
      } else {
        // unselect all selected instances
        instancesToUnselect = this.outer.querySelectorAll(
          `product-configurator-item-form[data-configurator-item-type="${subtype}"].is-selected`
        )
      }

      if (instancesToUnselect.length) {
        instancesToUnselect.forEach((instance) => {
          instance.dispatchEvent(
            new CustomEvent("configurator:item:unselect", {
              bubbles: true
            })
          )
        })
      }
      if (instancesToSelect.length) {
        instancesToSelect.forEach((instance) => {
          instance.dispatchEvent(
            new CustomEvent("configurator:item:select", {
              bubbles: true,
              detail: {
                data: selectedSecondary
              }
            })
          )
        });
      }
    }

    resetStates() {
      var instancesToUnselect = this.outer.querySelectorAll(
        `product-configurator-item-form.is-selected`
      );

      if (instancesToUnselect.length) {
        instancesToUnselect.forEach((instance) => {
          instance.dispatchEvent(
            new CustomEvent("configurator:item:unselect", {
              bubbles: true
            })
          )
        })
      }
    }

    resetModalState() {
      document.dispatchEvent(
        new CustomEvent('configurator:view:toggle', {
          bubbles: true,
          detail: {
            to: 'default',
            from: 'default'
          }
        })
      )
    }

    resetFormData() {
      this.formData = [];
      this.storeFormData(this.formData);
    }

    getFormData() {
      const storedConfiguratorFormData = localStorage.getItem(PRODUCT_CONFIGURATOR_FORM_STORAGE_KEY);
      const configuratorFormData = JSON.parse(storedConfiguratorFormData);

      window.configurator.formData = configuratorFormData ? configuratorFormData : [];
      this.setFormDataVariable();
    }

    storeFormData(data) {
      const dataString = JSON.stringify(data);

      localStorage.setItem(PRODUCT_CONFIGURATOR_FORM_STORAGE_KEY, dataString);
      window.configurator.formData = data;
      this.setFormDataVariable();
    }

    setFormDataVariable() {
      this.formData = window.configurator.formData;
    }

    _renderCartError(errorText) {
      this.submitError.textContent = errorText;
      this.submitError.classList.remove('is-hidden');
      setTimeout(()=>{
        this.submitError.classList.add("is-hidden");
      }, 3000);
    }

    _renderCartDrawer(text) {
      const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
      const cartCountInnerHTML = sectionInnerHTML.getElementById('cart-drawer-toggle').innerHTML;
      const cartDrawerInnerHTML = sectionInnerHTML.getElementById('Cart-Drawer').innerHTML;

      const cartCountElemToReplace = document.getElementById('cart-drawer-toggle');
      cartCountElemToReplace.innerHTML = cartCountInnerHTML;

      const cartDrawerElemToReplace = document.getElementById('Cart-Drawer');
      cartDrawerElemToReplace.innerHTML = cartDrawerInnerHTML;
      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }

      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }
    }
  }

  customElements.define('product-configurator-form', ProductConfiguratorForm);
}

if (!customElements.get('product-configurator-item-form')) {
  /**
   *  @class
   *  @function ProductConfiguratorItemForm
   */
  class ProductConfiguratorItemForm extends HTMLElement {
    constructor() {
      super();
      
      this.outer = this.closest('product-configurator-modal');
      if (!this.outer) return;

      this.form = this.outer.querySelector('product-configurator-form');
      this.viewOrigin = this.dataset.configuratorModalViewOrigin;
      this.subtype = this.dataset.configuratorItemType;
      this.productIdAttr = this.dataset.productId;
      this.productId = parseFloat(this.productIdAttr);
  
      this.variantSelect = this.querySelector('variant-selects-configurator');
      this.propertyInputs = this.querySelectorAll('[name^="properties"]');
      this.selectedProperties = {};
  
      this.toggleSelectButton = this.querySelector('[name="configurator-item-toggle-select"]');
      this.showCustomizeButton = this.querySelector('[name="configurator-item-show-customize"]');
      this.hideCustomizeButton = this.querySelector('[name="configurator-item-hide-customize"]');
      this.customizeWrapper = this.querySelector('[data-configurator-item-customize-wrapper]');
    }

    connectedCallback() {
      if (this.variantSelect) { 
        this.variantSelect.addEventListener('change', this.onVariantChange.bind(this)); 
      } else { 
        // select default variant
        this.selectedVariant = this.getVariantData()[0];
      }
      if (this.propertyInputs.length) {
        this.propertyInputs.forEach((input) => {
          input.addEventListener('change', this.onPropertyChange.bind(this));
        })
      }
      
      if (this.toggleSelectButton) { 
        this.toggleSelectButtonText = this.toggleSelectButton.querySelector('[data-button-text]'); 
        this.toggleSelectButton.addEventListener('click', this.onToggleFormItem.bind(this));
      }
      if (this.showCustomizeButton) {
        this.showCustomizeButton.addEventListener('click', this.onToggleCustomizeOptions.bind(this));
      }
      if (this.hideCustomizeButton) {
        this.hideCustomizeButton.addEventListener('click', this.onToggleCustomizeOptions.bind(this));
      }

      this.addEventListener(
        'configurator:item:select',
        function(evt) {
          var selectedSecondary = evt.detail.data;
          this.selectedVariant = this.getVariantDataById(selectedSecondary.id);
          this.selectedProperties = selectedSecondary.properties;
          this.setStateSelected();
        }.bind(this)
      );
      this.addEventListener(
        'configurator:item:unselect', 
        function() {
          this.selectedVariant = null;
          this.selectedProperties = {};
          this.setStateUnselected();
        }.bind(this)
      );
    }

    setStateSelected() {
      this.toggleMasterClass(true);
      this.setOptions(this.selectedVariant.id);
      this.setPropertyInputs(this.selectedProperties);
      if (this.toggleSelectButton) {
        this.updateSelectButton(); 
      }
      if (this.toggleSelectButtonText) {
        this.updateSelectButtonText(theme.configuratorStrings.unselect);
      }
    }

    setStateUnselected() {
      this.toggleMasterClass(false);
      this.resetOptions();
      this.resetPropertyInputs();
      if (this.toggleSelectButton) {
        this.updateSelectButton(); 
      }
      if (this.toggleSelectButtonText) {
        this.updateSelectButtonText(theme.configuratorStrings.select);
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.updateSelectedVariant();
      this.updateFormItem();
      if (this.toggleSelectButton) { 
        this.updateSelectButton(); 
      }
    }

    onPropertyChange(evt) {
      const target = evt.currentTarget;
      const targetName = target.getAttribute('name');
      const targetKey = targetName
        .replace(/properties/g, '')
        .replace(/[^a-zA-Z ]/g, '');

      this.updateSelectedProperties(targetKey, target.value);
      this.updateFormItem();
      if (this.toggleSelectButton) {
        this.updateSelectButton();
      }
    }

    onToggleFormItem() {
      this.formData = this.getFormData();

      var toggleModalView = null;
      var toggleSelectButtonText = theme.configuratorStrings.select;
      
      if (this.toggleSelectButton) {
        this.toggleSelectButton.setAttribute('disabled', 'disabled');
        this.toggleSelectButton.classList.add('loading');
      }

      if (!this.selectedVariant) return;
      
      const data = {
        id: this.selectedVariant.id,
        quantity: 1,
        properties: this.selectedProperties,
        _helpers: {
          _type: 'secondary',
          _subtype: this.subtype,
          _product_id: this.productId,
          _view_origin: this.viewOrigin,
          _price: this.selectedVariant.price,
          _racquet: this.formData[0]._helpers._handle
        }
      };
      
      if (this.subtype === 'mains') {
        data.properties['Direction'] = 'MAIN TENSION';
      } else if (this.subtype === 'crosses') {
        data.properties['Direction'] = 'CROSS TENSION';
      }
      if (this.subtype !== 'none') {
        data._helpers["_subtype_index"] = window.configurator._helpers._subtypes.findIndex((item) => item === this.subtype) + 1;
      }

      const foundSecondary = this.formData.find((item) => item.id === this.selectedVariant.id && item._helpers?._subtype === this.subtype);
      
      if (foundSecondary) {
        // remove current
        this.formData = this.formData.filter((item) => item.id !== this.selectedVariant.id || item._helpers?._subtype !== this.subtype);
      } else {
        // remove others
        this.formData = this.formData.filter((item) => item._helpers?._type !== 'secondary' || item._helpers?._subtype !== this.subtype);
        // add current
        this.formData.push(data);

        if (this.subtype === 'mains') { toggleModalView = `multicollection-2`; }
        else { toggleModalView = 'summary'; }
        toggleSelectButtonText = theme.configuratorStrings.unselect;
      }

      this.toggleMasterClass(true);
      this.triggerFormUpdate();

      setTimeout(() => {
        if (this.toggleSelectButton) {
          this.toggleSelectButton.classList.remove('loading');
          this.updateSelectButton();
          this.updateSelectButtonText(toggleSelectButtonText);
        }

        if (toggleModalView) {
          document.dispatchEvent(
            new CustomEvent('configurator:view:toggle', {
              bubbles: true,
              detail: {
                to: toggleModalView,
                from: this.viewOrigin
              }
            })
          )
        }
      }, 500);
    }

    onToggleCustomizeOptions() {
      if (!this.customizeWrapper) return;
      
      if (this.customizeWrapper.classList.contains('is-hidden')) {
        this.customizeWrapper.classList.remove('is-hidden');
        this.showCustomizeButton.classList.add('is-hidden');
        this.hideCustomizeButton.parentElement.classList.remove('is-hidden');
      } else {
        this.customizeWrapper.classList.add('is-hidden');
        this.showCustomizeButton.classList.remove('is-hidden');
        this.hideCustomizeButton.parentElement.classList.add('is-hidden');
      }
    }

    updateFormItem() {
      this.formData = this.getFormData();

      if (!this.selectedVariant) return;

      const foundSecondaryIndex = this.formData.findIndex((item) => item._helpers?._product_id === this.productId && item._helpers?._subtype === this.subtype);
      if (foundSecondaryIndex !== -1) {
        // update current
        this.formData[foundSecondaryIndex].id = this.selectedVariant.id;
        this.formData[foundSecondaryIndex]._helpers._view_origin = this.viewOrigin;
        this.formData[foundSecondaryIndex]._helpers._price = this.selectedVariant.price;

        this.toggleMasterClass(true);
        this.triggerFormUpdate();
      }
    }

    updateOptions() {
      this.options = [];
      this.fieldsets = Array.from(this.variantSelect.querySelectorAll('fieldset'));
      this.fieldsets.forEach((fieldset) => {
        var select = fieldset.querySelector('select');
        var inputs = fieldset.querySelectorAll('input');

        if (select) {
          this.options.push(select.value);
        } else if (inputs.length) {
          if (inputs.length === 1) {
            inputs[0].checked = true;
          }
          
          var checkedInput = fieldset.querySelector('input:checked');
          if (checkedInput) this.options.push(checkedInput.value);
        }
      });

      this.updateOtherOptions();
    }

    updateOtherOptions() {
      const variantData = this.getVariantData();
      if (!variantData) return;

      let selectedOptions = false;
      if (this.selectedVariant) {
        selectedOptions = this.selectedVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
      } else {
        let foundOption = variantData.find(option => {
          return option.option1 === this.options[0];
        });
        if (foundOption) {
          selectedOptions = [
            {
              "value": this.options[0],
              "index": "option1"
            },
            {
              "value": foundOption.option2,
              "index": "option2"
            }
          ];
        }
      }

      const availableOptions = this.createAvailableOptionsTree(variantData, selectedOptions);

      this.fieldsets.forEach((fieldset, i) => {
        const fieldsetOptions = Object.values(availableOptions)[i];

        if (fieldsetOptions) {
          if (fieldset.querySelector('select')) {
            fieldsetOptions.forEach((option) => {
              if (option.isUnavailable) {
                fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
              } else {
                fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
              }
            });
          } else if (fieldset.querySelectorAll('input').length) {
            fieldset.querySelectorAll('input').forEach((input, index) => {
              input.classList.toggle('is-disabled', fieldsetOptions[index].isUnavailable);
            });
          }
        }
      });
    }

    updateSelectedVariant() {
      this.selectedVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateSelectedProperties(key, val) {
      this.selectedProperties[key] = val;
    }

    updateSelectButton() {
      if (this.selectedVariant && Object.keys(this.selectedProperties).length >= this.propertyInputs.length) {
        this.toggleSelectButton.removeAttribute('disabled');
      } else {
        this.toggleSelectButton.setAttribute('disabled', 'disabled');
      }
    }

    updateSelectButtonText(text) {
      this.toggleSelectButtonText.textContent = text;
    }

    setOptions(id) {
      if (!this.variantSelect) return;

      var targetVariant = this.getVariantDataById(id);
      var targetOptions = targetVariant.options;

      targetOptions.forEach((option, index) => {
        var fieldset = this.variantSelect.querySelector(`fieldset[data-index="option${index + 1}"]`);
        var select = fieldset.querySelector('select');
        var inputs = fieldset.querySelectorAll('input');

        if (select) {
          select.value = option;
        } else if (inputs.length) {
          var inputToCheck = fieldset.querySelector(`input[value="${option}"]`);
          if (inputToCheck) { 
            inputToCheck.checked = true;
          }
        }
      });
    }

    setPropertyInputs(properties) {
      if (!this.propertyInputs.length) return;

      Object.keys(properties).forEach((key) => {
        const targetPropertyInput = this.querySelector(`[name="properties[${key}]"]`);
        if (targetPropertyInput) {
          targetPropertyInput.value = properties[key];
        }
      })
    }

    resetOptions() {
      if (!this.variantSelect) return;

      this.fieldsets = Array.from(this.variantSelect.querySelectorAll('fieldset'));
      this.fieldsets.forEach((fieldset) => {
        var variantSelect = fieldset.querySelector('select');
        var variantInputs = fieldset.querySelectorAll('input');

        if (variantSelect) {
          variantSelect.value = "";
        } else if (variantInputs.length) {
          variantInputs.forEach((input) => { input.checked = false; });
        }
      });
    }

    resetPropertyInputs() {
      this.propertyInputs.forEach((input) => {
        input.selectedIndex = 0;
      })
    }

    toggleMasterClass(selected) {
      if (selected) this.classList.add('is-selected');
      else this.classList.remove('is-selected');
    }

    triggerFormUpdate() {
      this.form.dispatchEvent(
        new CustomEvent("configurator:form:update", {
          bubbles: true,
          detail: {
            data: this.formData
          }
        })
      );
    }

    getVariantData() {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    getVariantDataById(id) {
      return this.getVariantData().find((variant) => variant.id === id);
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }
          const currentOption1 = currentlySelectedValues && currentlySelectedValues.length ? currentlySelectedValues.find(({ value, index }) => index === 'option1') : null;
          const currentOption2 = currentlySelectedValues && currentlySelectedValues.length ? currentlySelectedValues.find(({ value, index }) => index === 'option2') : null;

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getFormData() {
      return window.configurator.formData;
    }
  }

  customElements.define('product-configurator-item-form', ProductConfiguratorItemForm);
}

if (!customElements.get('product-configurator-upsell-item-form')) {
  /**
   *  @class
   *  @function ProductConfiguratorUpsellItemForm
   */
  class ProductConfiguratorUpsellItemForm extends HTMLElement { 
    constructor() {
      super();

      this.outer = this.closest('product-configurator-modal');
      this.form = this.outer.querySelector('product-configurator-form');

      this.addButton = this.querySelector('[name="configurator-upsell-item-add"]');
      this.qtyInput = this.querySelector('[name="configurator-upsell-item-quantity"]');
      this.removeButton = this.querySelector('[data-configurator-summary-item-remove]');
      this.qtyInputObserver = this.querySelector('[name="configurator-summary-item-quantity"]');

      this.variantId = parseFloat(this.getAttribute('data-variant-id'));
      this.price = parseFloat(this.getAttribute('data-price'));
    }

    connectedCallback() {
      if (isNaN(this.variantId)) return;

      this.formData = this.getFormData();

      if (this.addButton) {
        this.addButton.addEventListener("click", this.onAddFormItem.bind(this));
      }
      if (this.removeButton) {
        this.removeButton.addEventListener("click", this.onRemoveFormItem.bind(this));
      }
      if (this.qtyInputObserver) {
        this.initQuantityObserverValue();
        this.qtyInputObserver.addEventListener("change", this.onUpdateFormItem.bind(this));
      }
    }

    initQuantityObserverValue() {
      const foundAddOn = this.formData.find((item) => item.id === this.variantId);
      if (foundAddOn) {
        this.qtyInputObserver.value = foundAddOn.quantity;
      }
    }

    onRemoveFormItem() {
      this.formData = this.getFormData();

      const foundAddOn = this.formData.find((item) => item.id === this.variantId);
      if (foundAddOn) {
        this.formData = this.formData.filter((item) => item.id !== this.variantId);
      }

      this.triggerFormUpdate();
    }

    onAddFormItem() {
      this.formData = this.getFormData();
      
      if (this.addButton) {
        this.addButton.setAttribute('disabled', 'disabled');
        this.addButton.classList.add('loading');  
      }

      var qty = 1;
      if (this.qtyInput) {
        var qtyValue = parseFloat(this.qtyInput.value);
        if (!isNaN(qtyValue) && qtyValue > 0) qty = qtyValue;
      }

      const data = {
        id: this.variantId,
        quantity: qty,
        _helpers: {
          _type: 'add_on',
          _price: this.price
        }
      }

      const foundAddOnIndex = this.formData.findIndex((item) => item.id === this.variantId);
      if (foundAddOnIndex !== -1) {
        // update
        this.formData[foundAddOnIndex].quantity += qty;
      } else {
        // add
        this.formData.push(data);
      }

      this.triggerFormUpdate();

      setTimeout(() => {
        if (this.addButton) { 
          this.addButton.removeAttribute('disabled');
          this.addButton.classList.remove('loading');
        }
      }, 500);
    }

    onUpdateFormItem() {
      this.formData = this.getFormData();

      var qtyValue = parseFloat(this.qtyInputObserver.value);

      const foundAddOnIndex = this.formData.findIndex((item) => item.id === this.variantId);
      if (foundAddOnIndex !== -1) {
        if (!isNaN(qtyValue) && qtyValue > 0) {
          this.formData[foundAddOnIndex].quantity = qtyValue;
        }
      }

      this.triggerFormUpdate();
    }

    triggerFormUpdate() {
      this.form.dispatchEvent(
        new CustomEvent("configurator:form:update", {
          bubbles: true,
          detail: {
            data: this.formData
          }
        })
      );
    }

    getFormData() {
      return window.configurator.formData;
    }
  }

  customElements.define('product-configurator-upsell-item-form', ProductConfiguratorUpsellItemForm);
}